module.exports = __webpack_public_path__ + "static/media/rear-left.823e8d21.jpg";